import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";



function Clients() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/clients"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Our Clients</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Our Clients</li>
      </ul>
    </div>
  </div>
  <section id="integrations" className="py-100 integrations-2 integrations-section division">
    <div className="container">
      {/* INTEGRATIONS WRAPPER */}
      <div className="int-2-wrapper">
        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5">
          {/* INTEGRATION TOOL #1 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/d90d0535-ad22-47fa-2e6a-60374fd93c00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Vardhman Realty</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #1 */}
          {/* INTEGRATION TOOL #2 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/4da268e9-bfb1-4eb7-3623-df066f369a00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Aneilkkhare</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #2 */}
          {/* INTEGRATION TOOL #3 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid lt-img" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/16e79490-d8c2-4b56-a13c-b90d8dd06800/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Aile Properties</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #3 */}
          {/* INTEGRATION TOOL #4 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/e81edd05-9687-4718-a866-604bc6fdcf00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">MEDGULF</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #4 */}
          {/* INTEGRATION TOOL #5 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/f683b347-b1a1-40db-36bc-3bcbae6f5100/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Heaven Crest</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #5 */}
          {/* INTEGRATION TOOL #6 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/755eee34-eba8-4a15-ed2f-cabca7832d00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Tech Group</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #6 */}
          {/* INTEGRATION TOOL #7 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/5cb55d4b-362c-4b25-af22-704a7118c900/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Amber Clinic</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #7 */}
          {/* INTEGRATION TOOL #8 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/b2c25806-5dce-46fa-06ac-4dbdb9da5300/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Unisto</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #8 */}
          {/* INTEGRATION TOOL #9 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/7c7cca94-e918-4a56-e15a-041cbddae900/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Aland</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #9 */}
          {/* INTEGRATION TOOL #10 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/6580d53f-2011-4e8b-de0a-6dc5670fa300/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">HELIA RAD</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #10 */}
          {/* INTEGRATION TOOL #11 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/0858feb1-d83c-4e1e-f7a3-465063b72c00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">La Capitale</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #11 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/683779a3-c87d-478f-1584-1b1d30de9900/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">mir design group</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/48d8673f-98a3-437e-b12e-d5ddfb667b00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Numero</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/88d558f0-a777-4957-3326-ddd7e80dc000/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Kat Black</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/089a1b09-78a4-4f03-905d-9370a8476b00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Wepro</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/1d10ba32-bec8-41d6-4c7c-47eb779cce00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">ZEE Development</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/0727740b-63be-464e-b3cc-6d29b7aada00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Amourion</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/ba0f351d-827f-4370-f67b-0b4ad9503500/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Al Himayah</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/40ddb866-c42d-4a9f-4410-e04b8eeffa00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">Atelier Clinic</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
          {/* INTEGRATION TOOL #12 */}
          <div className="col">
            <a href="#">
              <div className="int_tool-2 r-12 wow animate__ animate__fadeInUp animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
                <img className="img-fluid" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/36a46888-83ec-4f00-c25e-ba98a7b99b00/w=1920,sharpen=1" alt="tool-logo" style={{pointerEvents: 'all !important'}} />
                <h6 className="fs-18">WOOF</h6>
              </div>
            </a>
          </div>	{/* END INTEGRATION TOOL #12 */}
        </div>
      </div>	{/* END INTEGRATIONS WRAPPER */}
    </div>     {/* End container */}
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default Clients;
